import {createSlice} from '@reduxjs/toolkit';

const organizationSclice = createSlice({
    name: 'organization',
    initialState: {
        loading: false,
        organization_list: [],
        organization_my: [],
        organization_id: {},
        organization_rating: [],
        organization_specialists_specialization: [],
        organization_specialists: [],
        search_spec_form: {
            type: '0',
            specialization: ''
        },
        organization_categories: [],
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setOrganization_specialists_specialization: (state, action) => {
            state.organization_specialists_specialization = action.payload
        },
        setOrganization_categories: (state, action) => {
            state.organization_categories = action.payload
        },
        setOrganization_specialists: (state, action) => {
            state.organization_specialists = action.payload
        },
        setOrganization_list: (state, action) => {
            state.organization_list = action.payload
        },
        setOrganization_my: (state, action) => {
            state.organization_my = action.payload
        },
        setOrganization_rating: (state, action) => {
            state.organization_rating = action.payload
        },
        setOrganization_id: (state, action) => {
            state.organization_id = action.payload
        },
        setSearch_spec_form: (state, action) => {
            state.search_spec_form = action.payload
        },
    },
});

export const { 
    setLoading,
    setOrganization_specialists_specialization,
    setOrganization_specialists,
    setOrganization_list,
    setOrganization_my,
    setOrganization_rating,
    setOrganization_id,
    setSearch_spec_form,
    setOrganization_categories
} = organizationSclice.actions
export default organizationSclice.reducer;